import * as vallas_request from "../request/vallas";
import _ from "lodash";
export default {
  data() {
    return {
      //   types:[],
      //            cardinal_directions:[],
      locations: [],
      dirs_trans: [
        { id: 1, abre: "N", text: "norte" },
        { id: 2, abre: "E", text: "este" },
        { id: 3, abre: "E", text: "este" },
        { id: 4, abre: "W", text: "oeste" },
        { id: 5, abre: "S", text: "sur" },
        { id: 6, abre: "NE", text: "noreste" },
        { id: 6, abre: "NW", text: "noroeste" },
        { id: 6, abre: "SE", text: "sureste" },
        { id: 6, abre: "SW", text: "suroeste" }
      ]
    };
  },
  methods: {
    getCardinalDirs() {
      let vm = this;
      vallas_request.facings().then(response => {
        vm.cardinal_directions = response.data.data;
      });
    },
    returnType(id) {
      let result = _.find(this.types, { id: id });
      if (result) {
        return result;
      }
      return { name: "..." };
    },
    returnDir(id) {
      let resultDir = _.find(this.cardinal_directions, { id: id });
      if (resultDir) {
        let text = this.getTransDir(resultDir.name);
        resultDir.name = text ? text : resultDir.name;
        return resultDir;
      } else {
        return { name: "..." };
      }
    },
    getTransDir(abr) {
      let result = _.find(this.dirs_trans, element => {
        return element.abre == abr;
      });
      if (result) {
        return result.text;
      } else {
        return false;
      }
    },
    returnCiudad(id) {
      let result = _.find(this.ciudades, { id: id });
      if (result) {
        return result.name;
      } else {
        return "...";
      }
    }
  }
};
